import RecordBase from './../tools/RecordBase';

class BusBase extends RecordBase {

  constructor () {
    super();
    this.state.cls = 'busbases';
    this.title = 'Bus Base';
  }
}

export default BusBase;
